export const Menu = {
  parts: ['item', 'list'],
  baseStyle: {
    fontFamily: 'body',
    list: {
      borderColor: 'border',
      boxShadow: '0px 6px 12px rgba(46, 67, 77, 0.1) !important',
      borderRadius: '8px',
    },
    item: {
      bg: 'white',
      _hover: {
        bg: 'white',
      },
      _focus: {
        bg: 'white',
      },
    },
  },
};
